import { GET_SMS_SCHEMAS, GET_ASTERISK_SERVERS } from '../types/actions.types';
import helper from '../../service/helper';
import { SET_ALL } from '../types/mutations.types';
import Misc from '../../api/methods/Misc';

const state = {
  smsSchemas: [],
  asteriskServers: [],
  activePopoverId: null
};

const getters = {
  smsSchemas () {
    return state.smsSchemas;
  },
  asteriskServers () {
    return state.asteriskServers;
  },
  activePopoverId () {
    return state.activePopoverId;
  }
};

const actions = {
  async [GET_SMS_SCHEMAS] (vuex, { context, params } = {}) {
    if (!helper.isEmpty(vuex.state.smsSchemas)) {
      return Promise.resolve(vuex.state.smsSchemas);
    }
    try {
      const { payload } = await Misc.getSmsSchemas();
      vuex.commit(SET_ALL, { data: payload, key: 'smsSchemas' });
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  async [GET_ASTERISK_SERVERS] (vuex, { context, params } = {}) {
    // if (!helper.isEmpty(vuex.state.asteriskServers)) {
    //   return Promise.resolve(vuex.state.asteriskServers);
    // }
    try {
      const { payload } = await Misc.getAsteriskServers();
      vuex.commit(SET_ALL, { data: payload, key: 'asteriskServers' });
      return Promise.resolve(payload);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  },

  setActivePopoverId ({ commit }, id) {
    commit('SET_ACTIVE_POPOVER_ID', id);
  }
};

const mutations = {
  [SET_ALL] (state, { data, key }) {
    state[key] = data;
  },
  SET_ACTIVE_POPOVER_ID (state, id) {
    state.activePopoverId = id;
  }
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters
};
